import { environment } from '../../../environments/environment';

export class AdminSound {
  private _soundId: number;
  get soundId(): number {
    console.log('counter');
    return this._soundId;
  }
  set soundId(value: number) {
    this._soundId = value;
  }
  soundText: string;
  soundFile: string;
  regionSoundFile: string;
  regionId: number;
  soundFileApi: string;
  regionSoundFileApi: string;

  constructor(json?: any, user?: any) {
    if (!json) {
      return;
    }
    this.soundFile = json.soundFile + '?t=' + Date.now().toString();
    this.soundId = json.soundId;
    this.soundText = json.soundText;
    this.regionId = json.regionId;
    this.regionSoundFile = json.regionSoundFile
      ? json.regionSoundFile + '?t=' + Date.now().toString()
      : null;
    this.soundFileApi =
      environment.api.baseUrl +
      environment.api.adminSounds.play
        .replace('{regionId}', this.regionId.toString())
        .replace('{filename}', this.soundFile) +
      '&access_token=' +
      encodeURIComponent(user ? user.token : '');

    if (this.soundFileApi) {
      this.regionSoundFileApi =
        environment.api.baseUrl +
        environment.api.adminSounds.play
          .replace('{regionId}', this.regionId.toString())
          .replace('{filename}', this.soundFile) +
        '&access_token=' +
        encodeURIComponent(user ? user.token : '');
    }
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/models/AdminSound.ts